import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/dinamicos/Ver/{id}',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['126'],
  cita: 'Areas/ReportesBI/Controllers/ReportesDinamicosController.cs:71',
} satisfies RutaProd;
